import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
import Form from "@rjsf/material-ui"
import PropTypes from 'prop-types'
import React from 'react'
import { formSchema, uiSchema } from './schema'


const EditVehicleDialog = props => {
	const [open, setOpen] = React.useState(false);
	const OnEditVehicle = props.OnEditVehicle;

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const onSubmit = (value, callback) => {
		value.formData._id = props.vehicle._id;
		setOpen(false)
		OnEditVehicle(value.formData);
	};


	return (
		<div>
			<Tooltip title='Edit a Vehicle'>
				<IconButton aria-label="edit" onClick={handleClickOpen} size='small'>
					<EditIcon />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>

				<DialogTitle id="form-dialog-title">Edit Vehicle</DialogTitle>
				<DialogContent>
					<Form
						schema={formSchema}
						onSubmit={onSubmit}
						uiSchema={uiSchema}
						formData={props.vehicle}
						// liveValidate
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} color="primary">
								Save
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</div>
	)
}

EditVehicleDialog.propTypes = {
	OnEditVehicle: PropTypes.func.isRequired,
}

export default EditVehicleDialog
